import { render, staticRenderFns } from "./host_open.vue?vue&type=template&id=0923166a&scoped=true"
import script from "./host_open.vue?vue&type=script&lang=js"
export * from "./host_open.vue?vue&type=script&lang=js"
import style0 from "./host_open.vue?vue&type=style&index=0&id=0923166a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0923166a",
  null
  
)

export default component.exports